import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import TimeStreamZoomTools from './TimeStreamZoomTools';
import { isCanvasLocked } from '../viewstate';

export default observer(function TimeStreamToolsLayer() {
    return <div className={styles.toolsLayer}>{!isCanvasLocked() && <TimeStreamZoomTools />}</div>;
});
